<input #field
       type="email"
       class="form-control"
       [ngModel]="innerValue"
       (ngModelChange)="writeValue($event)"
       (blur)="onTouched()">
